import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { logoColor } from "../../../theme";
import { ClinicInfo } from "../../../utils/makeClinicInfo";

export const PdfFooter = ({ clinics }: { clinics: Array<ClinicInfo> }) => {
	return (
		<View style={styles.footer} fixed>
			<Text style={styles.footerText}>
				<Text style={styles.footerBold}>NeuroImprove Clinic</Text>
				{"\n"}
				{/*<AllClinicsNames clinics={clinics}/>*/}
				www.neuroimprove.pt
			</Text>
		</View>
	);
};

/*
const AllClinicsNames = ({ clinics }: { clinics: Array<ClinicInfo> }) => {
	return (
		<>
			{clinics.map((clinic, index) => (
				<Text key={index}>
					{clinic.name}
					{index < clinics.length - 1 ? " | " : ""}
				</Text>
			))}
			{"\n"}
		</>
	)
}
*/

// If more content lines are added to the footer, the page paddingBottom must increase.
// 68 is safe for 2 lines, 80 is safe for 3 lines.
export const PDF_FOOTER_PAGE_PADDING_BOTTOM = 68;

const styles = StyleSheet.create({
    footer: {
		position: "absolute",
		bottom: 30,
		left: 50,
		right: 50,
		textAlign: "center",
		fontSize: 8.5,
		paddingTop: 8,
		borderTopWidth: 1,
		borderTopColor: "#cbd5e0",
	},
	footerText: {
		color: logoColor,
	},
	footerBold: {
		fontWeight: "bold",
		color: logoColor,
		fontSize: 9,
	},
})
